import { Box } from '@mui/material';
import AudioWave from '@frontend/features/common/components/AudioWave';

interface ChatAudioProps {
  fileId: string;
  size?: 'regular' | 'compact';
}

export const ChatAudio = ({ fileId, size = 'regular' }: ChatAudioProps) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    width="100%"
    minWidth={size === 'compact' ? 140 : 200}
    maxWidth={size === 'compact' ? 260 : 360}
  >
    <AudioWave fileId={+fileId} />
  </Box>
);
